export const validatePesel = (pesel?: string | null) => {
  if (!pesel) {
    return true;
  }

  // const reg = /^[0-9]{11}$/;

  const reg = /^[a-zA-Z0-9]+$/;

  if (reg.test(pesel) === false) {
    return false;
  }

  //uncomment all below to enable pesel validation (without letters)
  // else {
  //   const digits = ('' + pesel).split('');

  //   let checksum =
  //     (parseInt(digits[0], 10) +
  //       3 * parseInt(digits[1], 10) +
  //       7 * parseInt(digits[2], 10) +
  //       9 * parseInt(digits[3], 10) +
  //       parseInt(digits[4], 10) +
  //       3 * parseInt(digits[5], 10) +
  //       7 * parseInt(digits[6], 10) +
  //       9 * parseInt(digits[7], 10) +
  //       parseInt(digits[8], 10) +
  //       3 * parseInt(digits[9], 10)) %
  //     10;
  //   if (checksum === 0) {
  //     checksum = 10;
  //   }
  //   checksum = 10 - checksum;

  //   if (parseInt(digits[10], 10) !== checksum) {
  //     return false;
  //   }
  // }

  return true;
};
